module.exports = __webpack_public_path__ + "static/media/esign_intro_illustration_myway.476ba789.svg";